import { setPublicPath } from "systemjs-webpack-interop";

setPublicPath("@logistic-assistant/styleguide", 2);
